import { useMemo } from "react";
import { ILead } from "../../../models/Lead";
import LeadNotes from "../LeadInformation/LeadNotes";
import VehicleNotes from "../LeadInformation/VehicleNotes";
import StatusTabs, { StatusTabItem } from "../../shared/Tabs/StatusTabs";

export default function LeadNotesTab({ lead }: { lead: ILead }) {
  const tabs = useMemo<StatusTabItem[]>(() => {
    return [
      {
        key: "office-notes",
        title: "Office Notes",
        status: lead.officeNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="officeNotes" title="Office Notes" />,
      },
      {
        key: "driver-notes",
        title: "Driver Notes",
        status: lead.driverNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="driverNotes" title="Driver Notes" />,   
      },
      {
        key: "yard-notes",
        title: "Yard Notes",
        status: lead.yardNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="yardNotes" title="Yard Notes" />,   
      },
      {
        key: "vehicle-notes",
        title: "Vehicle Notes",
        status: lead.vehicle?.notes ? "complete" : "incomplete",
        children: <VehicleNotes vehicle={lead.vehicle!} />,   
      },
    ];
  }, [lead]);

  return <StatusTabs tabs={tabs} defaultTabKey="office-notes" />;

  return (
    <div className="p-4">
      <div className="grid grid-cols-1 md:grid-cols-4 md:gap-x-4 gap-y-4">
        <LeadNotes lead={lead} notesProp="officeNotes" title="Office Notes" />
        <LeadNotes lead={lead} notesProp="driverNotes" title="Driver Notes" />
        <LeadNotes lead={lead} notesProp="yardNotes" title="Yard Notes" />
        <VehicleNotes vehicle={lead.vehicle!} />
      </div>
    </div>
  );
}
